import { isEmptyString, trimChars } from "@shared/Utils";

export const TAG_URL_PARAM = "tag";
export const TAGLIST_URL_PARAM = "magasineTagList";

export const TAB_EVENTS = {
  UPDATE_MAGAZINE_FILTER: "magazineFilter",
};

export const parseIntEx = (string: string, defaultValue = 0): number => {
  const num = Number.parseInt(string, 10);
  return Number.isNaN(num) ? defaultValue : num;
};

export const setActiveClass = (newTag: string, itemList: Array<HTMLElement>): void => {
  for (const item of itemList) {
    item.classList.remove("magazine-tag-menu__item--active");
    delete item.dataset.sideScrollActive;
  }

  const newActiveItem = itemList.find(
    (el: HTMLElement) => (el.dataset.value as string).toLowerCase() === newTag.toLowerCase(),
  );
  if (newActiveItem) {
    newActiveItem.classList.add("magazine-tag-menu__item--active");
    newActiveItem.dataset.sideScrollActive = "";
  }
};

export const getTagList = (container: HTMLElement): string[] => {
  const tags = container.dataset.magazineTagList as string;
  return isEmptyString(tags) ? [] : tags.split(",");
};

export const getActiveTab = (tabList: string[]) => {
  const urlParams = new URLSearchParams(window.location.search);
  const initialTag = urlParams.get(TAG_URL_PARAM);
  if (initialTag) return initialTag;

  // remove start and end slash (trim), and split by slash
  const pathNames = trimChars(window.location.pathname, "/").split("/");
  if (!pathNames) return "";
  // We have to replace underscore with space in order to carry out the correct comparison
  const lastPath = pathNames[pathNames.length - 1] as string;
  const currentTag = tabList.find((x) => toUrlSlug(x).toLowerCase() === toUrlSlug(lastPath).toLowerCase());

  return currentTag ? currentTag : "";
};

export const updateUrlHistory = (newTag: string, basePath: string): void => {
  const curBasePath = basePath.endsWith("/") ? basePath : `${basePath}/`;
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(TAG_URL_PARAM);
  const urlParamString = urlParams.toString() ? `?${urlParams.toString()}` : "";
  if (newTag !== "undefined" && !isEmptyString(newTag)) {
    window.history.pushState(null, "", `${curBasePath}emne/${toUrlSlug(newTag).toLowerCase()}/${urlParamString}`);
  } else {
    window.history.pushState(null, "", `${curBasePath}${urlParamString}`);
  }
};

export const toUrlSlug = (url: string) => {
  const urlLower = url.toLowerCase();
  return urlLower
    .replace("å", "a")
    .replace("ø", "o")
    .replace("æ", "ae")
    .replace(/[^\w\s-]/g, "")
    .replace(/_/g, "")
    .replace(/\s+/g, "-")
    .replace(/-{2,}/g, "-");
};
